<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div class="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Institutes</h5>
                            <div class="row text-center">
                                <div class="col">
                                    <label class="switch">
                                        <input v-model="addTab" type="checkbox" id="togBtn" @change="resetAlerts(true)">
                                        <div class="slider round">
                                            <span style="font-size: 15px;" class="off">Edit</span>
                                            <span style="font-size: 15px;" class="on">Add New</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div v-if="addTab == false">
                                <div class="row mb-5">
                                    <div class="col-3">
                                        <select class="form-control custom-dropdown" v-model="selectedMuseum" @change="resetAlerts()">
                                            <option disabled selected value="">Pick an Institute</option>
                                            <option v-for="museum in museums" :key="museum.id" :value="museum">{{ museum.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectedMuseum.address">
                                    <div class="row mb-4">
                                        <div class="col-4">
                                            <label>Name:</label>
                                            <input v-model="selectedMuseum.name" type="text" class="form-control"/>
                                        </div>
                                        <div class="col-4">
                                            <label>Address:</label>
                                            <input v-model="selectedMuseum.address.address_1" type="text" class="form-control"/>
                                        </div>
                                        <div class="col-4">
                                            <label>Address 2:</label>
                                            <input v-model="selectedMuseum.address.address_2" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="row mb-4">
                                        <div class="col-3">
                                            <label>City:</label>
                                            <input v-model="selectedMuseum.address.city" type="text" class="form-control"/>
                                        </div>
                                        <div class="col-3">
                                            <label>State/Province:</label>
                                            <input v-model="selectedMuseum.address.state" type="text" class="form-control"/>
                                        </div>
                                        <div class="col-3">
                                            <label>Postal Code:</label>
                                            <input v-model="selectedMuseum.address.postal_code" type="text" class="form-control"/>
                                        </div>
                                        <div class="col-3">
                                            <label>Country:</label>
                                            <input v-model="selectedMuseum.address.country" type="text" class="form-control"/>
                                        </div>
                                    </div>

                                    <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                    <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                    
                                    <div class="row mb-4">
                                        <div v-if="selectedMuseum.image != null" class="col-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <p>{{ selectedMuseum.image.split('/').pop() }}</p>
                                                </div>
                                                <div class="card-body">
                                                    <img :src="selectedMuseum.image" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                                :options="imageDropzoneOptions" 
                                                :useCustomSlot=true 
                                                v-on:vdropzone-sending="appendFileName"
                                                @vdropzone-file-added="fileInDropzone=true"
                                                @vdropzone-removed-file="fileInDropzone=false">
                                                <div class="dropzone-custom-content">
                                                    <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                    <div class="subtitle">accepted file types: png, jpg, jpeg <br><br>Recommended Aspect Ratio: <b>138:95</b></div>
                                                </div>
                                            </Dropzone>
                                            <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary mt-5" @click="updateMuseum()">Update Institute</button>
                                    <button class="btn btn-primary btn-danger mt-5 float-right" @click="deleteMuseum()"><i class="text-white fa fa-trash"></i> Delete Institute</button>
                                </div>
                            </div>

                            <div v-else>
                                <div class="row mb-4">
                                    <div class="col-6">
                                        <label>* Name:</label>
                                        <input v-model="newMuseum.name" type="text" class="form-control"/>
                                    </div>
                                    <div class="col-6">
                                        <label>Country:</label>
                                        <select class="form-control custom-dropdown" v-model="selectedCountry" @change="getStatesForCountry()">
                                            <option disabled selected value="">Pick a Country</option>
                                            <option v-for="country in countries" :key="country.id" :value="country">{{ country.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="selectedCountry != ''" class="row mb-4">
                                    <div class="col">
                                        <label>Address:</label>
                                        <input v-model="newMuseum.address1" type="text" class="form-control"/>
                                    </div>
                                    <div class="col">
                                        <label>Address 2:</label>
                                        <input v-model="newMuseum.address2" type="text" class="form-control"/>
                                    </div>
                                </div>
                                <div v-if="selectedCountry != ''" class="row mb-4">
                                    <div class="col">
                                        <label>City:</label>
                                        <input v-model="newMuseum.city" type="text" class="form-control"/>
                                    </div>
                                    <div class="col">
                                        <label>State:</label>
                                        <select v-if="states.length > 0" class="form-control custom-dropdown" v-model="selectedState">
                                            <option disabled selected value="">Pick a State</option>
                                            <option v-for="state in states" :key="state.id" :value="state">{{ state.code }}</option>
                                        </select>
                                        <input v-else v-model="selectedState" type="text" class="form-control"/>
                                    </div>
                                    <div class="col">
                                        <label>Postal Code:</label>
                                        <input v-model="newMuseum.postalCode" type="text" class="form-control"/>
                                    </div>
                                </div>

                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                
                                <div class="row mb-4">
                                    <div class="col-6" v-if="selectedMuseum.image != null">
                                        <div class="card">
                                            <div class="card-header">
                                                <p>{{ selectedMuseum.image.split('/').pop() }}</p>
                                            </div>
                                            <div class="card-body">
                                                <img :src="selectedMuseum.image" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <Dropzone name="dropzone" id="dropzone" ref="imageDropzone" 
                                            :options="imageDropzoneOptions" 
                                            :useCustomSlot=true 
                                            v-on:vdropzone-sending="appendFileName"
                                            @vdropzone-file-added="fileInDropzone=true"
                                            @vdropzone-removed-file="fileInDropzone=false">
                                            <div class="dropzone-custom-content">
                                                <h5 class="dropzone-custom-title">Click here or drag and drop an image</h5>
                                                <div class="subtitle dropzone-custom-sub">accepted file types: png, jpg, jpeg <br><br>Recommended Aspect Ratio: <b>138:95</b></div>
                                            </div>
                                        </Dropzone>
                                        <button v-if="fileInDropzone" class="btn btn-outline-danger ml-4" @click="removeImage">Clear Dropzone</button>
                                    </div>
                                </div>
                                <button class="btn btn-primary mt-5" @click="createNew()">Create Institute</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pending Institutes Approvals -->
                <div class="row" v-if="isSuperAdmin">
                    <div class="card">

                        <div class="card-header">
                            <h5 class="card-title">Institutes Pending Approval</h5>
                        </div>

                        <div class="card-body">
                            <v-client-table :data="museumsPendingApproval" :columns="museumsPendingColumns" :options="museumsPendingOptions">
                                <div slot="pendingActions" slot-scope="{row}">
                                    <button @click="approvePending(row)" class="transparent-button ml-3"><i class="edit-button fa fa-check"></i> Approve</button>
                                    <button @click="rejectPending(row)" class="transparent-button ml-3"><i class="delete-button fa fa-times"></i> Reject</button>
                                </div>
                            </v-client-table>
                        </div>

                    </div>
                </div>


            </div>
            <Footer />
        </div>

        <v-dialog />

    </div>
</template>

<script>
import Museums from '../controllers/museum.controller';
import Countries from '../controllers/countries.controller';
import States from '../controllers/states.controller';
import Addresses from '../controllers/addresses.controller';

import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import isSuperAdmin from "@/services/jwt/isSuperAdmin";
import Artists from "@/controllers/artist.controller";

export default {
    name: 'Museums',
    components: {
        Dropzone
    },
    data: function() {
        return {
            addTab: false,
            loading: false,
            countries: [],
            states: [],
            museums: [],

            museumsPendingApproval: [],
            museumsPendingColumns: ['name', 'address', 'createdBy', 'created_at', 'pendingActions'],
            museumsPendingOptions: {
                perPage: 10,
                pagination: { chunk: 10, dropdown: false },
                filterable: false,
                headings: {
                    name: 'Name',
                    address: 'Address',
                    createdBy: 'Created By',
                    created_at: 'Created At',
                    pendingActions: 'Actions'
                },
                sortIcon: {
                    base : 'fa',
                    is: 'fa-sort',
                    up: 'fa-sort-asc',
                    down: 'fa-sort-desc'
                }
            },

            selectedMuseum: '',
            selectedCountry: '',
            selectedState: '',
            newMuseum: {},
            imageDropzoneOptions: {
                url: (process.env.VUE_APP_API_URL + '/museum/upload/2') || "http://localhost:3001/museum/upload/2",
                maxFilesize: 50, // Mb
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: '.png,.jpg,.jpeg',
                header: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                }
            },
            fileInDropzone: false,
            errorMessage: '',
            successMessage: '',
            isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin'))
        }
    },

    beforeMount: async function() {
        this.loading = true;

        await this.loadMuseums();
        this.countries = await Countries.getAll();

        this.loading = false;
    },

    methods: {

        async loadMuseums() {

            this.museums = [];
            let pendingMuseums = [];

            let allMuseums = await Museums.getAll();

            allMuseums.forEach((museum) => {
                if (museum.approved) {
                    this.museums.push(museum);
                } else {

                    let createdAt = new Date(museum.created_at);
                    let day = createdAt.getDate() < 10 ? "0" + createdAt.getDate() : createdAt.getDate();
                    let month = (createdAt.getMonth() + 1) < 10 ? "0" + (createdAt.getMonth() + 1) : (createdAt.getMonth() + 1);
                    createdAt = month + "/" + day + "/" + createdAt.getFullYear();

                    pendingMuseums.push({
                        id: museum.id,
                        name: museum.name,
                        address: museum.address.address_1 + ' ' + museum.address.city + ' ' + museum.address.state + ' ' + museum.address.postal_code + ' ' + museum.address.country,
                        createdBy: museum.createdBy !== null ? "@" + museum.createdBy.display_name : "N/A",
                        created_at: createdAt
                    });
                }
            });
            this.museumsPendingApproval = pendingMuseums;

        },

        async approvePending(museum) {

            this.successMessage = '';
            this.errorMessage = '';

            let approved = await Museums.approve(museum.id);

            if (approved === false) {
                this.errorMessage = 'An error occurred approving the Institute. Please try again.'
                this.successMessage = '';
            } else {
                this.errorMessage = ''
                this.successMessage = 'Institute successfully approved.';

                // Refresh the artist list
                await this.loadMuseums();

                this.$modal.show('dialog', {
                    title: 'Institute Approved',
                    text: museum.name + " has been successfully approved.",
                    buttons: [
                        {
                            title: 'OK',
                            handler: () => {
                                this.$modal.hide('dialog');
                            }
                        }
                    ]
                });

            }
        },

        async rejectPending(museum) {

            this.successMessage = '';
            this.errorMessage = '';

            this.$modal.show('dialog', {
                title: 'Reject Institute?',
                text: 'Rejecting the institute will permanently delete it from the system. Are you sure you want to delete the institute?',
                buttons: [
                    {
                        title: 'Cancel',
                        handler: () => {
                            this.$modal.hide('dialog')
                        }
                    },
                    {
                        title: 'DELETE',
                        class: 'vue-dialog-button vue-dialog-button-red',
                        handler: async () => {
                            this.$modal.hide('dialog');
                            await this._deleteMuseum(museum.id);

                        }
                    }
                ]
            });

        },

        async resetAlerts(resetMuseum = false) {
            if (resetMuseum) {
                this.selectedMuseum = '';
            }
            this.successMessage = '';
            this.errorMessage = '';
            this.newMuseum = {};
            await this.loadMuseums();
            this.countries = await Countries.getAll();
        },

        removeImage() {
            this.$refs.imageDropzone.removeAllFiles();
        },

        async getStatesForCountry () {
            this.states = await States.getForCountryID(this.selectedCountry.id);
        },

        async createNew() {
            this.loading = true;

            let state = !this.selectedState.name ? this.selectedState : this.selectedState.code;

            let added = await Museums.createNew(this.newMuseum.name, this.newMuseum.address1, this.newMuseum.address2, 
                                                this.newMuseum.city, state, this.newMuseum.postalCode, this.selectedCountry.name);

            if (added.id) {
                this.errorMessage = '';
                // Refresh the museums list
                this.selectedMuseum = added;
                if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                    this.$refs.imageDropzone.processQueue();
                } else {
                    await this.loadMuseums();
                    this.successMessage = 'Institute created successfully';
                }
            } else if (added.error) {
                this.errorMessage = added.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while creating your institute';
                this.successMessage = '';
            }

            this.loading = false;
        },

        async updateMuseum() {
            this.loading = true;
            this.errorMessage = "";
            this.successMessage = "";

            let updatedAddress = await Addresses.update(this.selectedMuseum.address_id, this.selectedMuseum.address.address_1, this.selectedMuseum.address.city, this.selectedMuseum.address.state, this.selectedMuseum.address.postal_code, this.selectedMuseum.address.country, this.selectedMuseum.address.address_2);
            
            if (updatedAddress === false) {
                this.errorMessage = "Something went wrong while updating your institute's address";
            } else if (updatedAddress.error) {
                this.errorMessage = updatedAddress.error;
            } else {
                
                let museumUpdated = await Museums.update(this.selectedMuseum.id, this.selectedMuseum.name, updatedAddress);
                if (museumUpdated === false) {
                    this.errorMessage = "Something went wrong while updating your institute";
                } else if (museumUpdated.error) {
                    this.errorMessage = museumUpdated.error;
                } else {
                    if (this.$refs.imageDropzone.dropzone.files.length > 0) {
                        this.$refs.imageDropzone.processQueue();
                    } else {
                        this.successMessage = "Institute updated successfully";
                    }
                }
            }

            this.loading = false;
        },

        async appendFileName(file, xhr, formData) {
            file.upload.filename = Date.now() + file.upload.filename.slice(file.upload.filename.lastIndexOf('.'), file.upload.filename.length);
            let uploaded = await Museums.uploadImage(this.selectedMuseum.id, file.upload.filename, file.dataURL);
            if (uploaded === false) {
                this.errorMessage = "Something went wrong with uploading your image"
            } else if (uploaded.error) {
                this.errorMessage = uploaded.error;
            } else {
                this.errorMessage = '';
                this.selectedMuseum.image = uploaded.image;
                await this.loadMuseums();
                this.successMessage = this.addTab === true ? "Institute was created successfully" : "Institute updated successfully";
                this.$refs.imageDropzone.removeAllFiles();
            }
        },

        async deleteMuseum() {
            await this._deleteMuseum(this.selectedMuseum.id)
        },

        async _deleteMuseum(id) {
            this.loading = true;
            let deleted = await Museums.delete(id);

            if (deleted === true) {
                this.errorMessage = '';
                this.successMessage = 'Institute deleted successfully';

                // Refresh the museums list
                await this.loadMuseums();

                // Remove the museum info from the form
                this.selectedMuseum = '';

            } else if (deleted.error) {
                this.errorMessage = deleted.error;
                this.successMessage = '';
            } else {
                this.errorMessage = 'Something went wrong while deleting your institute';
                this.successMessage = '';
            }
            this.loading = false;
        }
    }
}
</script>